import type { CanvasComponent, ProjectDocument, RestAction } from '../../types/project';

export type ComponentReference = {
  kind: 'binding' | 'actionTemplate';
  label: string;
};

function bindingPathReferencesComponent(path: string, componentName: string): boolean {
  const root = `components.${componentName}`;
  return path === root || path.startsWith(`${root}.`);
}

function actionTemplateEntries(action: RestAction): Array<[string, string | undefined]> {
  return [
    ['URL', action.url],
    ['body', action.bodyTemplate],
    ...Object.entries(action.headers ?? {}).map(([key, value]) => [`header "${key}"`, value] as [string, string]),
    ...Object.entries(action.queryParameters ?? {}).map(([key, value]) => [`query parameter "${key}"`, value] as [string, string]),
    ...Object.entries(action.pathParameters ?? {}).map(([key, value]) => [`path parameter "${key}"`, value] as [string, string]),
  ];
}

export function findComponentReferences(doc: ProjectDocument, componentName: string): ComponentReference[] {
  const references: ComponentReference[] = [];
  const template = `{{components.${componentName}.value}}`;

  for (const binding of doc.project.bindings) {
    if (bindingPathReferencesComponent(binding.source, componentName)) {
      references.push({ kind: 'binding', label: `Binding "${binding.id}" source` });
    }
    if (bindingPathReferencesComponent(binding.target, componentName)) {
      references.push({ kind: 'binding', label: `Binding "${binding.id}" target` });
    }
  }

  for (const action of doc.project.actions) {
    for (const [location, value] of actionTemplateEntries(action)) {
      if (value?.includes(template)) {
        references.push({ kind: 'actionTemplate', label: `Action "${action.name}" ${location}` });
      }
    }
  }

  return references;
}

export type PendingComponentDeletion = {
  component: CanvasComponent;
  references: ComponentReference[];
};
